import React, { useRef, useState, useMemo } from "react";
import _ from "lodash";
import BackButton from "../../component/BackButton/BackButton";
import ThemeLayout from "../../layout/themeLayout";
import Button from "../../component/Button/Button";
import Icon from "../../component/Icon/Icon";
import { Link } from "react-router-dom";
import RoundImage from "../../component/Image/RoundImage";
import { PLACEHOLDER } from "../../helpers/constant";
import styles from "./help.module.css";
import { Modal, ModalFooter } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getFormData } from "../../helpers/utility";
import { setErrorMessages, validateRequired } from "../../helpers/validationMessages";
import Error from "../../component/Error/Error";
import Joi from "joi";
import Input from "../../component/Input/Input";
import { useEffect } from "react";
import { clippingParents } from "@popperjs/core";
import { supportTickets as supportTicketsApi } from "../../api/support_tickets";
import { getMessages as getMessagesApi } from "../../api/support_tickets";
import { createTicket as createTicketApi } from "../../api/support_tickets";
import { createMessage as createMessageApi } from "../../api/support_tickets";
import { formattedDate, getCalendarDate } from "../../helpers/dates";
import { toast } from "react-toastify";
import { useCallback } from "react";
import { getSocket } from "../../core/socket";
import moment from "moment";
import ScrollList from "../../component/ScrollList/ScrollList";

export default function HelpAndSupport() {
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const [showModal, setShowModal] = useState(false);
    const formRef = useRef();
    // const msgRef = useRef();
    const [message, setMessage] = useState("");
    const [historyPagination, setHistoryPagination] = useState({
        current_page: 1,
    });
    const [tickets, setTickets] = useState([]);
    const [selectedTicket, setSelectedTicket] = useState();
    const messages = useRef([]);
    const [supportPagination, setSupportPagination] = useState({
        current_page: 1,
    });

    const sendMessage = () => {
        // let fd = new FormData(msgRef.current);

        // let msgText = fd.get('message');

        // if (!msgRef.current.value) {
        //     return;
        // }

        dispatch(
            createMessageApi({
                data: {
                    support_ticket_id: selectedTicket?.id,
                    user_type: "user",
                    message,
                },
                method: "POST",
            }),
        )
            .then((response) => {
                if (response.success) {
                    // getSocket().emit("messaging", response.data);
                    // debugger;
                    messages.current = [response.data].concat(messages.current).sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));
                    setMessage("");
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const loadMoreTickets = () => {
        // console.log(`getting page no ${supportPagination.current_page + 1}`)
        getSupportTickets(10, supportPagination.current_page + 1)
    }

    const transformChatByGroup = useMemo(() => {
        let rtVal = _.chain(messages.current)
            .groupBy((m) => getCalendarDate(m.created_at))
            .reduce((result, value, key) => {
                result[key] = value;
                return result;
            }, {})
            .value();

        // console.log("transforming");

        return rtVal;
    }, [messages.current, historyPagination, selectedTicket]);

    // const onSendMessage = () => {
    //     console.log("hello");
    // }

    const onKeyDown = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            sendMessage(event);
        }
    };

    const renderMessages = ({ item }) => {
        return (
            <li key={item.id} className={`d-item d-flex my-2 align-items-start ${item.user_type == "admin" ? "flex-row" : "flex-row-reverse"} `} style={{ gap: "3px" }}>
                <RoundImage className={`img-thumbnail`} src={item?.source_user?.profile_pic || PLACEHOLDER} alt="" size="35px" />
                <div className={`d-flex flex-column ${styles[`${item.user_type == "admin" ? "you" : "me"}`]}`}>
                    <span className={`${styles["chat-message-item"]}`}>{item.message}</span>
                    <small className={`text-right`}>
                        <time dateTime={item.created_at} className="entry-date updated">
                            {moment(item.created_at).format("hh:mm a")}
                        </time>
                    </small>
                </div>
            </li>
        );
    };

    const renderChatItem = useCallback(
        (key) => {
            const chatgroup = transformChatByGroup[key];
            return (
                <React.Fragment key={key}>
                    {chatgroup?.map((item) => renderMessages({ item }))}
                    <li className="text-center" style={{ listStyle: "none" }}>
                        <p>{key}</p>
                    </li>
                </React.Fragment>
            );
        },
        [renderMessages, transformChatByGroup],
    );

    const getSupportTickets = (per_page, page_no = 1) => {

        let params = {
            per_page,
            page_no
        };

        dispatch(
            supportTicketsApi({
                params,
            }),
        )
            .then((response) => {
                if (response.success) {
                    setTickets(tickets.concat(response.data))
                    setSupportPagination(response.pagination_data)
                    console.log(response.pagination_data)
                    console.log(supportPagination)
                }
            })
            .catch((e) => {
                console.log(e);
            });
        }

    useEffect(() => {
        getSupportTickets(10, 1);
        // dispatch(supportTicketsApi())
        //     .then((response) => {
        //         if (response.success) {
        //             setTickets(response.data);
        //         }
        //     })
        //     .catch((e) => {
        //         console.log(e);
        //     });
    }, []);

    const createNewTicket = () => {
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const onSubmitForm = (e) => {
        setErrors({});
        const formSchema = Joi.object({
            title: Joi.string().required().messages({
                "string.empty": "Title is required",
            }),
            description: Joi.string().required().messages({
                "string.empty": "Description is required",
            }),
        });

        e.preventDefault();
        const formData = new FormData(formRef.current);

        let data = {
            title: formData.get("title"),
            description: formData.get("description"),
        };
        const { error } = formSchema.validate(data, { abortEarly: false });
        if (error) {
            const t = setErrorMessages(error);

            return setErrors(t);
        }

        dispatch(
            supportTicketsApi({
                data,
                method: "POST",
            }),
        )
            .then((response) => {
                if (response.success) {
                    // console.log("yes");
                    setShowModal(false)
                    setTickets([response.data].concat(tickets))
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const getMessages = (per_page = 10) => {
        let params = {
            per_page,
        };

        if (messages.current.length > 0) {
            params.load = messages.current[messages.current.length - 1]?.id;
        }

        dispatch(
            getMessagesApi({
                path: `get-feedback-messages/${selectedTicket?.id}`,
                method: "GET",
                params,
            }),
        )
            .then((response) => {
                if (response.success) {
                    console.log("previous messages: ", messages.current);
                    messages.current = _.uniqBy(messages.current.concat(response.data), "id");
                    setHistoryPagination(response.pagination_data);
                    console.log("history pagination", response.pagination_data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const selectTicket = (t) => {
        setSelectedTicket(t);

        setTickets(
            tickets.map((tic) => {
                if (t.id == tic.id) {
                    tic.selected = true;
                } else {
                    tic.selected = false;
                }
                return tic;
            }),
        );
    };

    useEffect(() => {
        messages.current = [];

        setHistoryPagination({
            current_page: 1,
        });
        getMessages(10);
    }, [selectedTicket]);

    // const renderMessages = () => {
    //     return messages?.map((m) => {
    //         return (
    //             <div key={m}>
    //                { m &&
    //                     <div className={`d-item d-flex my-2 align-items-start ${m.user_type == 'admin' ? 'flex-row' : 'flex-row-reverse'} `} style={{ gap: "3px" }}>
    //                         <RoundImage src={PLACEHOLDER} size={`30px`} />
    //                         <div className={`message-pill d-flex flex-column ${styles[`${m.user_type == 'admin' ? 'you' : 'me'}`]}`}>
    //                             <span className={`${styles[`message`]}`}>
    //                                 {m.message}
    //                             </span>
    //                         </div>
    //                     </div>

    //                }
    //             </div>

    //         )
    //     });
    // };

    const renderOnEmptyChat = useMemo(() => {
        return (
            <div className={`${styles["chat-empty"]} text-center p-4`}>
                <p>Say Hi</p>
            </div>
        );
    }, []);

    // const loadTickets = () => {
    //     setTickets(tempArrTickets);
    // }

    // useEffect(() => {
    //     loadTickets();
    // }, [dispatch]);

    return (
        <div>
            <Modal id="submit-modal" show={showModal} onHide={handleCloseModal} backdrop="static" size="" centered={true}>
                <Modal.Header className="p-3 border-bottom">
                    <h4 className="modal-title">Create new ticket</h4>
                    <Button className="close" type="button" onClick={handleCloseModal}>
                        x
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-section">
                        <form ref={formRef} className={`mt-4`} onSubmit={onSubmitForm}>
                            <div className="row">
                                <div className={`col-md-12`}>
                                    <Input className={`uk-input`} name="title" styleType="floating" placeholder="Title" />
                                    {errors["title"] && <Error marginTop="-12px" error={errors["title"]} />}
                                </div>
                                <div className={`col-md-12`}>
                                    <Input className={`uk-input`} name="description" styleType="floating-area" placeholder="Description" />
                                    {errors["description"] && <Error marginTop="-12px" error={errors["description"]} />}
                                </div>
                                <div className="col-md-12 text-right">
                                    <Button className="btn btn-sm" htmlType="submit" type="button">
                                        Create
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <ThemeLayout>
                <section>
                    <div className="gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div id="page-contents" className="row merged20">
                                        <div className="col-lg-3">
                                            <aside className="sidebar static right" style={{ height: "100%" }}>
                                                <div className="widget stick-widget mb-0 shadow-none" style={{ height: "100%" }}>
                                                    <BackButton />
                                                    <div className={`${styles[`tickets-sections`]}`}>
                                                        <div className="sections-header py-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="sec-title">
                                                                    <h5>Tickets</h5>
                                                                </div>
                                                                <div className="actions d-flex ml-auto">
                                                                    <a className="text-info" href={`#`} onClick={createNewTicket}>
                                                                        {" "}
                                                                        Create New <Icon name={`ticket`} />{" "}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="sections-body border-top">
                                                            <div className={`${styles[`tickets`]}`}>
                                                                {tickets?.length > 0 &&
                                                                    tickets.map((t, i) => {
                                                                        return (
                                                                            <div
                                                                                onClick={() => selectTicket(t)}
                                                                                key={i}
                                                                                className={`tbox p-2 mt-3 rounded-sm border-light cursor-pointer d-flex flex-column shadow-sm ${
                                                                                    t.selected ? "text-white" : ""
                                                                                }`}
                                                                                style={{ background: `${t.selected ? "#17a2b8" : "#17a2b863"}` }}
                                                                            >
                                                                                <div className="ticket-num d-flex flex-row justify-content-between">
                                                                                    {t.status == 'closed' && <small className="badge badge-success text-dark">{t.status}</small>}
                                                                                    {t.status == 'opened' && <small className="badge badge-warning text-dark">{t.status}</small>}
                                                                                    <small>
                                                                                        Ticket # : <span className={`${t.selected ? "text-white" : ""}`}>{t.id}</span>
                                                                                    </small>
                                                                                </div>
                                                                                <hr className="my-1" />
                                                                                <div className="ticket-name mt-2 ">
                                                                                    <p className={`mb-0 text-truncate ${t.selected ? "text-white" : ""}`}>
                                                                                        Title: <b>{t.title}</b>
                                                                                    </p>
                                                                                </div>
                                                                                <div className="ticket-desc text-truncate">
                                                                                    <small className="">{t.description}</small>
                                                                                </div>
                                                                                <hr className="my-1" />
                                                                                <div className="ticket-date  ml-auto ">
                                                                                    <small>
                                                                                        Date: <span>{formattedDate(t.updated_at)}</span>
                                                                                    </small>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </div>
                                                            {supportPagination.current_page < supportPagination.last_page && <div className="loadmore mt-2"  onClick={loadMoreTickets}><a data-ripple="true" className="btn-sm">Load More..</a></div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </aside>
                                        </div>

                                        {selectedTicket && (
                                            <div className="col-lg-9">
                                                <div className="card" style={{ height: "100%" }}>
                                                    <div className="card-header p-2 border-bottom">
                                                        <div className="d-flex">
                                                            <div className="ticket-info">
                                                                <div className="t-title">
                                                                    <h5>{selectedTicket?.title}</h5>
                                                                </div>
                                                            </div>
                                                            <div className="side-section ml-auto">
                                                                <div className="t-ticket-num">
                                                                    <small>
                                                                        Ticket # : <span className="text-info"> {selectedTicket?.id}</span>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="card-body p-2" style={{ background: "#17a2b812" }}>
                                                        <div>
                                                            <ul className={`${styles[`messages-pills-box`]} d-flex flex-column-reverse scrolable-div`}>
                                                                <ScrollList
                                                                    data={Object.keys(transformChatByGroup)}
                                                                    renderItem={renderChatItem}
                                                                    isReverse
                                                                    onEndReach={() => getMessages(10)}
                                                                    renderOnEmptyList={renderOnEmptyChat}
                                                                    threshold={10}
                                                                    hasMore={historyPagination.current_page < historyPagination.last_page}
                                                                    pagination={historyPagination}
                                                                />
                                                            </ul>
                                                            {selectedTicket.status == 'opened' && <form className="text-box" onSubmit={sendMessage}>
                                                                <div className={`input-group mb-3 ${styles[`message-input-area`]}`}>
                                                                    <textarea
                                                                        // ref={msgRef}
                                                                        onKeyDown={onKeyDown}
                                                                        name="message"
                                                                        placeholder="Write Mesage..."
                                                                        defaultValue={""}
                                                                        value={message}
                                                                        maxLength="200"
                                                                        onChange={(e) => setMessage(e.target.value)}
                                                                    />

                                                                    <button className="d-flex align-items-center btn-info btn-sm" htmlType="submit" type="button" onClick={sendMessage}>
                                                                        <i className="icofont-paper-plane" />
                                                                    </button>
                                                                </div>
                                                            </form>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="main-wraper">
                                            </div> */}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </ThemeLayout>
        </div>
    );
}
